export const Square = require('./square.svg')
export const SemiCircle = require('./semicircle.svg')
export const Circle = require('./circle.svg')

